import type { IconNode } from '../types';

/**
 * @name layout-grid-move-vertical
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSI3IiB4PSIxNCIgeT0iMyIgcng9IjEiIC8+CiAgPHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iNyIgeD0iMTQiIHk9IjE0IiByeD0iMSIgLz4KICA8cGF0aCBkPSJtMiA3IDQtNCA0IDQiIC8+CiAgPHBhdGggZD0iTTYgM3YxOCIgLz4KICA8cGF0aCBkPSJtMiAxNyA0IDQgNC00IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/layout-grid-move-vertical
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const layoutGridMoveVertical: IconNode = [
  ['rect', { width: '7', height: '7', x: '14', y: '3', rx: '1', key: '6d4xhi' }],
  ['rect', { width: '7', height: '7', x: '14', y: '14', rx: '1', key: 'nxv5o0' }],
  ['path', { d: 'm2 7 4-4 4 4', key: '1es8kl' }],
  ['path', { d: 'M6 3v18', key: 'h4854d' }],
  ['path', { d: 'm2 17 4 4 4-4', key: '1mm42h' }],
];

export default layoutGridMoveVertical;
